import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useNavigate } from 'react-router-dom';
import success from '../../../assets/animation/success.json';

function OrderSuccess() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/customer-home'); // update path to your actual home route if needed
  };

  return (
    <div className="h-[calc(100vh-80px)] flex justify-center items-center px-4 overflow-y-auto">
      <div className="flex flex-col justify-center items-center bg-white rounded-xl shadow-lg p-8 w-full max-w-xl space-y-5">
        
        {/* Lottie Animation */}
        <Player
          autoplay
          loop={true}
          src={success}
          style={{ height: '300px', width: '300px' }}
        />

        <div className="text-4xl font-semibold text-center">Payment Confirmed!</div>
        <div className="text-xl text-[#565656] text-center">
          Thank you! Your transaction was successful
        </div>

        {/* <div className="flex justify-center items-center w-[380px] h-[50px] font-[600] text-[#3383B2] border border-[#3383B2] bg-[#EBF4F9] rounded-[5px]">
          Transaction ID: 947R93UJFI
        </div> */}

        <div className="text-lg font-[600] text-center">
          A receipt has been sent to your email!
        </div>

        {/* Go to Home Button */}
        <button
          onClick={handleGoHome}
          className="mt-4 px-6 py-2 bg-[#3383B2] text-white font-semibold rounded-[5px] hover:bg-[#2a6b8f] transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}

export default OrderSuccess;
